export default {
  "content": "<path d=\"M80 152v256a40.12 40.12 0 0040 40h272a40.12 40.12 0 0040-40V152\" class=\"ionicon-fill-none ionicon-stroke-width\"/><rect x=\"48\" y=\"64\" width=\"416\" height=\"80\" rx=\"28\" ry=\"28\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M320 304l-64 64-64-64m64 41.89V224\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};